<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <mat-toolbar color="accent"> Settings </mat-toolbar>

  <mat-dialog-content class="!text-black">
    <div class="flex flex-col gap-4">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Status</mat-label>
        <mat-select formControlName="dryRun">
          <mat-option [value]="false">Active</mat-option>
          <mat-option [value]="true">Dry Run</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Max Jobs</mat-label>
        <input matInput type="number" formControlName="maxJobs" min="1" />
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Max Job Size (Files)</mat-label>
        <input matInput type="number" formControlName="maxJobSize" min="1" />
      </mat-form-field>

      <mat-slide-toggle formControlName="enableTimingLogs">
        Enable Timing Logs
      </mat-slide-toggle>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button type="button" mat-stroked-button mat-dialog-close>Cancel</button>
    <button type="submit" color="primary" mat-flat-button>Save</button>
  </mat-dialog-actions>
</form>
